import { createSelector } from "reselect";
import { initialState } from "./../../reducers/manage/reducer";

const selectData = (state: any) => state.manage || initialState;

export const makeManageCardData = () =>
  createSelector(
    [selectData],
    (manage) => manage.manageCardData || initialState.manageCardData
  );

export const getCapacityToSeeResult = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacityToSeeResult || initialState.capacityToSeeResult
  );


export const getManageUsers = () =>
  createSelector(
    [selectData],
    (manage) => manage.users.data || initialState.users.data
  );

export const getManageUsersLoaded = () =>
  createSelector(
    [selectData],
    (manage) => manage.users.loaded || initialState.users.loaded
  );

export const getSelectedManageUser = () =>
  createSelector(
    [selectData],
    (manage) =>
      manage.users.selectedProfile || initialState.users.selectedProfile
  );

export const getSelectedFilter = () =>
  createSelector(
    [selectData],
    (manage) => manage.users.filter || initialState.users.filter
  );

export const isUserValidated = () =>
  createSelector(
    [selectData],
    (manage) => manage.users.validateUser.isUserValid
  );

export const getValidateUserDetails = () =>
  createSelector(
    [selectData],
    (manage) =>
      manage.users.validateUser.details ||
      initialState.users.validateUser.details
  );

export const isTransferRequested = () =>
  createSelector(
    [selectData],
    (manage) =>
      manage.users.transfer.isRequested ||
      initialState.users.transfer.isRequested
  );

export const getTransferRequestDetails = () =>
  createSelector(
    [selectData],
    (manage) =>
      manage.users.transfer.details || initialState.users.transfer.details
  );


export const getManageCapacity = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacity.data || initialState.capacity.data
  );

export const getManageCapacityRemainingRecords = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacity.remainingRecords || initialState.capacity.remainingRecords
  );

export const getManageCapacityTotalPages = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacity.totalPages || initialState.capacity.totalPages
  );

export const getManageCapacityLoaded = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacity.loaded || initialState.capacity.loaded
  );

export const selectCapacityLoadLoadPostings = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacityToSeeResult.data.loadPostings || initialState.capacityToSeeResult.data.loadPostings
  );
export const selectCapacityLoadCapacity = () =>
  createSelector([selectData], manage => {
    return manage.capacityLoad.capacity || initialState.capacityLoad.capacity;
  });
export const selectCapacityLoadCapacityLoadCount = () =>
  createSelector([selectData], manage => {
    return manage.capacityToSeeResult.data.loadCount || initialState.capacityToSeeResult.data.loadCount;
  });

export const countryStateCodesSelector = () =>
  createSelector(selectData, (manage) => manage.countryCodes);

export const getManageCapacityFilter = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacity.filter || initialState.capacity.filter
  );

export const getSelectedManageCapacity = () =>
  createSelector(
    [selectData],
    (manage) => manage.capacity.selected || initialState.capacity.selected
  );


export const getCarrierProfile = () =>
  createSelector(
    [selectData],
    (manage) => manage.carrierProfile.data || initialState.carrierProfile.data
  );

export const getCarrierProfileLoaded = () =>
  createSelector(
    [selectData],
    (manage) =>
      manage.carrierProfile.loaded || initialState.carrierProfile.loaded
  );

export const getManageSegmentSelected = () =>
  createSelector(
    [selectData],
    (manage) => manage.manageSegmentSelected || initialState.manageSegmentSelected
  );
